module.exports = __webpack_public_path__ + "static/media/decibel-se.215b71bc.md";